import {Grid} from '@material-ui/core';

const TabPanel = props => {
    const {children, value, index, ...other} = props;
    const style = {
        height: value === index ? '100%' : null,
        overflow: 'hidden',
    };

    return (
        <Grid
            container
            item
            direction='column'
            alignItems='center'
            xs={12}
            role='tabpanel'
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
            style={style}
        >
            {value === index && children}
        </Grid>
    );
};

export default TabPanel;
